__turbopack_context__.v({
  "className": "unbounded_2ec219ee-module__tgycCa__className",
});
